import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import spacings from '@/styles/spacings';

interface Props {
  title: string;
  desc: string;
}

const FieldLabelWithDescription: React.FC<Props> = ({ title, desc }) => (
  <Box flex={{ grow: 1 }}>
    <Text margin={{ bottom: 'spacing4' }} weight="bold" color="textBody">
      {title}
    </Text>
    <Box width={{ max: '300px' }}>
      <Text weight={500} size="small" color="textSecondary" style={{ lineHeight: spacings.spacing18 }}>
        {desc}
      </Text>
    </Box>
  </Box>
);

export default FieldLabelWithDescription;
